<template>
	<section class="is-simple">
		<div>
			<h2
				v-html="title ? title :
				`Perchè Quomi?`"
			/>
			<h3 v-if="!noSubtitle">
				Per dire basta alle solite ricette e alla solita spesa.<br> Torna a divertirti con noi in cucina!
			</h3>
			<div id="slider" class="mt-10" v-if="!$mq.isDesktop()">
				<SliderQ
					:minSizeOfSlide="200"
					:maxNumSlides='4'
					:arrow="!$mq.isDesktop()"
					isCentered
				>
					<slide class="px-6">
						<div>
							<div>
								<i class="pr-3"><img src="../../assets/img/badges/widget/chef.png" alt="chef" style="max-width: 50%"/></i>
								<h4 class="py-3">18 ricette nuove <br>ogni settimana</h4>
							</div>
							<div class="why-card">
								<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff">
									<ul class="why-list">
										<li>Scheda ricetta gratuita</li>
										<li>Nelle giuste dosi, per ridurre gli sprechi</li>
										<li>Pronte in 10/30 minuti!</li>
									</ul>
								</v-card>
							</div>
						</div>
					</slide>
					<slide class="px-6">
						<div>
							<div>
								<i class="pr-3"><img src="../../assets/img/badges/widget/cooking.png" alt="cooking"/></i> 
								<h4 class="py-3">Cucinare senza <br> pensare alla spesa</h4>
							</div>
							<div class="why-card">
								<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff">
									<ul class="why-list">
										<li>Consegna a domicilio in tutta Italia</li>
										<li>Zero vincoli</li>
										<li>Facile e sostenibile</li>
									</ul>
								</v-card>
							</div>
						</div>
					</slide>
					<slide class="px-6">
						<div>
							<div>
								<i class="pr-3"><img src="../../assets/img/badges/widget/quality.png" alt="quality" style="max-width: 50%"/></i> 
								<h4 class="py-3">Ingredienti di qualità,<br> artigianali, italiani </h4>
							</div>
							<div class="why-card">
								<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff">
									<ul class="why-list">
										<li>Freschezza e varietà</li>
										<li>Stagionali e per tutti i gusti</li>
										<li>+80 produttori certificati</li>
									</ul>
								</v-card>
							</div>
						</div>
					</slide>
					<slide class="px-6">
						<div>
							<div>
								<i class="pr-3"><img src="../../assets/img/badges/widget/coins.png" alt="coins" style="max-width: 50%"/></i> 
								<h4 class="py-3">Ricette da 4,50€ <br>a porzione</h4>
							</div>
							<div class="why-card">
								<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff">
									<ul class="why-list">
										<li>Più ordini, più risparmi</li>
										<li>Zero sprechi</li>
										<li>Scegli tu il numero di porzioni</li>
									</ul>
								</v-card>
							</div>
						</div>
					</slide>
				</SliderQ>
			</div>
			<div class="flex wrap is-simple-content" v-else>
				<div class="col-3 flex flex-column">
					<i><img src="../../assets/img/badges/widget/chef.png" alt="chef"></i> 
					<h4 class="pt-3 pb-5">18 ricette nuove,<br>ogni settimana</h4>
					<div class="why-card">
						<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff; align-self: center">
							<ul class="why-list">
								<li>Scheda ricetta gratuita</li>
								<li>Nelle giuste dosi, per ridurre gli sprechi</li>
								<li>Pronte in 10 / 30 minuti!</li>
							</ul>
						</v-card>
					</div>
				</div>
				<div class="col-3 flex flex-column">
					<i><img src="../../assets/img/badges/widget/cooking.png" alt="cooking"></i> 
					<h4 class="pt-3 pb-5">Il piacere di cucinare,<br>senza il pensiero della spesa</h4>
					<div class="why-card">
						<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff; align-self: center">
							<ul class="why-list">
								<li>Consegna a domicilio in tutta Italia</li>
								<li>Zero vincoli</li>
								<li>Facile e sostenibile</li>
							</ul>
						</v-card>
					</div>
				</div>
				<div class="col-3 flex flex-column">
					<i><img src="../../assets/img/badges/widget/quality.png" alt="quality"></i> 
					<h4 class="pt-3 pb-5">Ingredienti di qualità,<br>artigianali, italiani </h4>
					<div class="why-card">
						<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff; align-self: center">
							<ul class="why-list">
								<li>Freschezza e varietà</li>
								<li>Stagionali e per tutti i gusti</li>
								<li>+80 produttori certificati</li>
							</ul>
						</v-card>
					</div>
				</div>
				<div class="col-3 flex flex-column">
					<i><img src="../../assets/img/badges/widget/coins.png" alt="coins"></i> 
					<h4 class="pt-3 pb-5">Kit ricette<br>da 4,50€ a porzione</h4>
					<div class="why-card">
						<v-card color="var(--quomi-primary)" flat height="fit-content" class="pl-10 pr-3 py-3" style="color: #ffffff; align-self: center">
							<ul class="why-list">
								<li>Più ordini, più risparmi</li>
								<li>Zero sprechi</li>
								<li>Scegli tu il numero di porzioni</li>
							</ul>
						</v-card>
					</div>
				</div>
			</div>
			</div>
		</div>
	</section>
</template>

<script type="text/javascript">
	export default {
		props: {
			title: {
				type: String,
				default: null,
			},
			noSubtitle: {
				type: Boolean,
				default: false
			}
		}
	}
</script>


<style scoped>
section {
	text-align: center;
}

h2, h3 {
	text-align: center;
}

h4 {
	font-size: 16px;
	font-weight: bold;
	width: 100%;
}

.is-simple-content {
	padding-top: 25px;
}

.is-simple-img {
	max-height: 50px;
}

.is-simple-img-round {
	max-height: 200px;
}

.why-card {
	position: relative;
}

.why-card::before {
	content: '\f0d8';
	color: var(--quomi-primary);
	font-size: 3em;
	font-family: 'FontAwesome';
	position: absolute;
	top: -40px;
	right: 45%;
	z-index: 1;
}

.why-list {
	list-style: none;
	text-align: start;
	position: relative;
}

.why-list li{
	padding: 7px 0;
	font-weight: 600;
	font-size: 14px;
}

.why-list li::before {
	content: '\F00C';
	color: #ffffff;
	font-family: 'FontAwesome';
	margin-right: 5px;
	position: absolute;
	left: -25px;
}

@media only screen and (max-width: 768px) {
	.is-simple {
		border-bottom: 1px solid #ededed;
	}

	.is-simple-content .col-sm-12 + .col-sm-12{
		padding-top: 30px;
	}
}
</style>